import { render, staticRenderFns } from "./EHXTO.vue?vue&type=template&id=4230e512&scoped=true&"
import script from "./EHXTO.vue?vue&type=script&lang=js&"
export * from "./EHXTO.vue?vue&type=script&lang=js&"
import style0 from "./EHXTO.vue?vue&type=style&index=0&id=4230e512&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4230e512",
  null
  
)

export default component.exports